export default __webpack_public_path__ + "hamburger.cf859a6c.svg";